<template>
  <v-menu bottom offset-y transition="scale-transition">
    <template v-slot:activator="{ on }">
      <mf-tooltip v-if="disablePii" bottom max-width="300">
        <template #activator="{ on: tooltipOn }">
          <div v-on="tooltipOn">
            <component :is="buttonComponent" v-bind="buttonProps" />
          </div>
        </template>
        <span>Você não tem permissão para exportar dados pessoais sensíveis, verifique suas permissões com seu administrador.</span>
      </mf-tooltip>
      <div v-else v-on="{ ...(buttonProps.disabled ? {} : on) }">
        <component :is="buttonComponent" v-bind="buttonProps" />
      </div>
    </template>
    <v-list>
      <v-list-item @click="exportCsv">
        <v-list-item-title class="menu-export-item"
          ><mf-icon color="cinza-d20" small>draft</mf-icon> <span class="cinza-d10-text">Exportar .csv</span></v-list-item-title
        >
      </v-list-item>
      <v-list-item v-if="!disableXLSX" @click="exportXlsx">
        <v-list-item-title class="menu-export-item"
          ><mf-icon color="cinza-d20" small>view_list</mf-icon> <span class="cinza-d10-text">Exportar .xlsx</span></v-list-item-title
        >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { createCsvFromArray } from '@/config/helpers.js'
import * as XLSX from 'xlsx'

export default {
  name: 'ExportData',
  props: {
    dataFetcher: Function,
    filename: String,
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    buttonClass: {
      type: String,
      default: '',
    },
    buttonLabel: {
      type: String,
      default: 'Exportar dados',
    },
    ghost: {
      type: Boolean,
      default: false,
    },
    async: {
      type: Boolean,
      default: false,
    },
    disableXLSX: {
      type: Boolean,
      default: false,
    },
    isPii: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    lazyLoading: false,
  }),
  computed: {
    localLoading: {
      set(value) {
        this.lazyLoading = value
      },
      get() {
        return this.loading || this.lazyLoading
      },
    },
    buttonComponent() {
      return 'mf-button'
    },
    disablePii() {
      if (this.isPii && !this.hasPiiDownloadAccess) {
        return true
      }
      return false
    },
    buttonProps() {
      const baseProps = {
        disabled: this.disabled || this.disablePii,
        loading: this.localLoading,
      }

      if (this.ghost) {
        return {
          ...baseProps,
          text: true,
          color: 'marca-0-l40',
          class: `mx-2 ${this.buttonClass}`,
          label: this.buttonLabel,
          icon: 'download',
        }
      }

      return {
        ...baseProps,
        class: `btn-export ${this.buttonClass}`,
        label: 'Exportar',
      }
    },
  },
  methods: {
    async exportCsv() {
      this.localLoading = true
      try {
        if (this.async) {
          this.$emit('file-format', 'csv')
        } else {
          const data = await this.dataFetcher()
          createCsvFromArray(data.rows, this.formatFileName(this.filename), data.headers)
        }
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao exportar .csv', snackbarColor: 'error' })
      }
      this.localLoading = false
    },
    async exportXlsx() {
      this.localLoading = true
      try {
        if (this.async) {
          this.$emit('file-format', 'xlsx')
        } else {
          const data = await this.dataFetcher()
          const worksheet = XLSX.utils.aoa_to_sheet([data.headers, ...data.rows])
          const workbook = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados')
          XLSX.writeFile(workbook, `${this.formatFileName(this.filename)}.xlsx`)
        }
      } catch (error) {
        console.warn(error)
        this.$snackbar({ message: 'Erro ao exportar .xlsx', snackbarColor: 'error' })
      }
      this.localLoading = false
    },
    formatFileName(name) {
      return name.trim().replaceAll(' ', '_').toLowerCase()
    },
  },
}
</script>

<style lang="scss">
.cinza-d10-text {
  color: $cinza-d10;
  font-weight: 400;
  font-size: 14px;
  gap: 6px;
}

.menu-export-item {
  display: flex;
  gap: 6px;
}

.v-menu__content {
  border-radius: 8px;
}

.v-list-item {
  min-height: 40px;
}

.unset-capitalize {
  text-transform: unset !important;
  letter-spacing: $letterspacing-1;
}
</style>
